// libraries
import React, { useState, useEffect } from 'react'

// dependencies
import { Button, BUTTON_THEME, BUTTON_SIZE, Input } from '@st-operations/uikit/src/v2/index.js'

import User from '_lib/User'

// css
import './styles.scss'

// page
const RecoverPassword = ({ location }) => {
  const [state, setState] = useState({
    confirmPassword: '',
    newPassword: '',
    errorMsg: null,
    successMsg: null,
  })

  useEffect(() => {
    const prt = location?.search?.slice(5, 69)
    if (prt !== '') {
      localStorage.setItem('prt', prt)
    }
  }, [])

  const handleChange = (value, name) => {
    setState((prevState) => ({ ...prevState, [name]: value }))
  }

  const updatePassword = () => {
    let prt = localStorage.getItem('prt')
    // unable to retrieve password reset token
    if (!prt) {
      setState({
        errorMsg: `Cookies and LocalStorage must be enabled in
        your browser to reset your password`,
      })
    }
    // 2 passwords must match
    else if (state.newPassword !== state.confirmPassword) {
      setState((prevState) => ({
        ...prevState,
        errorMsg: `Your new password and confirmation password do
      not match`,
      }))
    } else {
      User.resetPassword(prt, state.newPassword, (err) => {
        if (err) {
          setState({ errorMsg: err.error })
          return
        }
        let msg = 'You have successfully reset your password'
        setState((prevState) => ({
          ...prevState,
          successMsg: msg,
        }))
        toast(msg)
        setTimeout(() => {
          window.location.href = '/login'
        }, 1000)
      })
    }
  }

  return (
    <div id="st-recover-password-page">
      <div className="st-recover-password-page__content">
        <div className="st-recover-password-page__title">Enter a new password</div>
        <If condition={state.errorMsg}>
          <div className="st-recover-password-page__error">{state.errorMsg}</div>
        </If>
        <If condition={state.successMsg}>
          <div className="st-recover-password-page__success">{state.successMsg}</div>
        </If>
        <Input
          onChange={handleChange}
          placeholder="New Password"
          value={state.newPassword}
          type="password"
          label="Password"
          name="newPassword"
        />

        <Input
          onChange={handleChange}
          placeholder="Confirm New Password"
          value={state.confirmPassword}
          label="confirmPassword"
          type="password"
          name="confirmPassword"
        />
        <Button theme={BUTTON_THEME.SECONDARY} size={BUTTON_SIZE.LARGE} onClick={updatePassword}>
          UPDATE PASSWORD
        </Button>
      </div>
    </div>
  )
}

// export
export default RecoverPassword
